module.exports = __webpack_public_path__ + "img/GenomeBiology.c6b72961.png";